import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9eb9bbfe"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw600" }, "更改网点", -1))
const _hoisted_2 = {
  key: 0,
  class: "network-info"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"rgba(0, 0, 0, 0.22)"} }, "请选择维修网点", -1))

import { useRouter } from 'vue-router'
import { withDefaults } from 'vue'
import { useMalfunctionRepairStore } from '@/compositions/malfunction-repair/index'
import CellWrap from './cell-wrap.vue'
import LabelTitleWrap from './label-title-wrap.vue'
import NetworkInfoItem from './network-info-item.vue'
import IconArrowRightWrap from '@/components/icon/IconArrowRightWrap.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'network-info-block',
  props: {
    changeMode: { default: 'back' },
    sn: { default: '' }
  },
  emits: ['jump'],
  setup(__props: any, { emit: emits }) {

const props = __props as { changeMode: string, sn: string };



const { malfunctionRepairState } = useMalfunctionRepairStore()
const $router = useRouter()
function changeNetwork() {
  emits('jump')
  if (props.changeMode === 'back') {
    $router.go(-1)
  } else {
    console.log('props.sn', props.sn)
    $router.push({
      name: 'malfunction-repair-network-list',
      query: {
        from: 'other',
        sn: props.sn,
      },
    })
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(LabelTitleWrap, {
      title: "维修网点",
      style: {"margin-top":"12px"}
    }, {
      default: _withCtx(() => [
        (_unref(malfunctionRepairState).networkInfo)
          ? (_openBlock(), _createBlock(IconArrowRightWrap, {
              key: 0,
              onClick: changeNetwork
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_unref(malfunctionRepairState).networkInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(NetworkInfoItem, {
            showPhone: false,
            item: _unref(malfunctionRepairState).networkInfo
          }, null, 8, ["item"])
        ]))
      : (_openBlock(), _createBlock(CellWrap, {
          key: 1,
          label: "维修网点",
          required: "",
          fillColor: "rgba(0, 0, 0, 0.44)",
          onClick: changeNetwork
        }, {
          "cell-right": _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }))
  ], 64))
}
}

})